/**
 * Created by Vishnu Todwal on 2023-08-18.
 */

import {WinPresentationController} from "../../WinPresentationController";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DDay} from "../../../DDay";
import {IBetWayWinData} from "../../../server/data/IBlitzKriegData";
import {BlitzkriegSymbols, BlitzKriegSymbolState} from "../../../symbol/DDaySymbolConfig";
import {BelowStakeWinRestriction} from "../../../server/BelowStakeWinRestriction";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BlitzKriegParsedGameData} from "../../../server/data/BlitzKriegParsedGameData";
import {DDaySymbol} from "../../../symbol/DDaySymbol";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "../../../view/DDayLayers";
import {BlitzKriegSound} from "../../../sound/BlitzKriegSound";

export class DDayNoWinController extends WinPresentationController {
    private _mainTimeline: TimelineLite | null;
    private _belowStakeWinRestriction: boolean;

    constructor() {
        super("InitialWinController", true);
    }

    protected hasWin(): boolean {
        return DDay.model.parsedGameData.betWins?.length === 0;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this.getWinAnimation());
        this._mainTimeline = tl;
        await Promise.resolve(tl);
        this._mainTimeline = null;
    }

    protected getWinAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this, {duration: 0.3});
        return tl;
    }

    protected skip() {
        this._mainTimeline?.progress(1);
    }
}
